<template>
  <section class="admin-main">
    <app-sidebar></app-sidebar>
    <div class="admin-content-wrapper">
      <router-view :key="key"></router-view>
    </div>
  </section>
</template>
<script>
import Sidebar from './sidebar'

export default {
  name: 'AppMain',
  components: { 'app-sidebar': Sidebar },
  computed: {
    key() {
      return this.$route + +new Date()
    }
  }
}
</script>
<style>
.admin-main {
  padding-top: 56px;
}
.admin-content-wrapper {
  position: relative;
  margin-left: 200px;
  padding: 24px;
}
.admin-content {
  position: relative;
  min-height: calc(100vh - 104px);
  background-color: #fff;
}
.w1000 {
  width: 1000px;
  margin: 0 auto;
}
</style>
